"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Renders an unstyled button HTML element with basic handling of button
 * attributes, e.g., type, onClick, and disabled.
 * 
 * To use, export a styled version of Button with your project's needs.
 * Below is an example of how one might configure a Button that uses an 
 * icon and text.
 * 

  ```
    import { Button as ButtonRaw } from "cosmic-react-conmmon-components";
    
    const Button = props => {
      const { iconName, text, ...rest } = props;

      return (
        <ButtonRaw {...rest}>
          {iconName && (
            <Icon name="iconName" />
          )}
          <Text tag="button">{text}</Text>
        </ButtonRaw>
      );
    };

    export default Button;
  ```
 */
var Button = function Button(_ref) {
  var onClick = _ref.onClick,
      type = _ref.type,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["onClick", "type", "className", "children"]);

  return (// eslint doesn't allow dynamically setting the type
    // eslint-disable-next-line react/button-has-type
    _react.default.createElement("button", _extends({
      type: type,
      className: "CosmicButton ".concat(className),
      onClick: onClick
    }, rest), children)
  );
};

Button.propTypes = {
  onClick: _propTypes.default.func,
  type: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
Button.defaultProps = {
  onClick: null,
  type: "button",
  className: "",
  children: null
};
var _default = Button;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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